<template>
<div class="chapter">
<div class="inner_page">
<p class="image2"><img alt="Image" src="images/4.jpg"/><a id="page_4"></a></p><a id="page_4">
<p class="para-c">THORNDIKE &amp; SWANN REGENCY MYSTERIES</p>
<p class="para-c"><em>The Debutante’s Code</em></p>
<p class="para-c"><em>Millstone of Doubt</em></p>
<p class="para-c"><em>Children of the Shadows</em></p>
<p class="para1">SERENDIPITY &amp; SECRETS</p>
<p class="para-c"><em>The Lost Lieutenant</em></p>
<p class="para-c"><em>The Gentleman Spy</em></p>
<p class="para-c"><em>The Indebted Earl</em></p>
<p class="para1"><em>Joy to the World: A Regency Christmas Collection</em> by Carolyn Miller, Amanda Barratt, and Erica Vetsch</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_FM02.vue?53597120